import * as R from 'ramda'
import { getStateFromLocalStorage } from 'domain/fromLocalStorage'
import { isActionType } from 'helpers/ramda-ext/actions'
import * as Actions from 'store/actions'
import { RegisteredAction } from 'store/actions/index.types'
import { InitialState, State } from './fromLocalStorage.types'

export const initialState: Readonly<InitialState> = getStateFromLocalStorage()

// eslint-disable-next-line @typescript-eslint/default-param-last
export default (state: State = initialState, action: RegisteredAction): State => R.cond([
  [
    isActionType(Actions.configurator.CONFIGURATOR_SELECTION_CHANGE),
    R.ifElse(
      R.pipe(
        R.path(['payload', 'isAutoSelect']),
        R.equals(false)
      ),
      () => R.mergeDeepRight(state, { configurator: R.path(['payload', 'selection'], action) }),
      R.always(state)
    )
  ], [
    R.T,
    R.always(state)
  ]
])(action)

export const getFromLocalStorage = R.prop('fromLocalStorage')
